import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-nav-14",
  "use": "icon-icon-nav-14-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-icon-nav-14\"><path d=\"M713.152 394.688h-33.536V327.616a167.68 167.68 0 0 0-335.232 0v67.072h-33.536A67.2 67.2 0 0 0 243.84 461.696v335.232A67.2 67.2 0 0 0 310.848 864h402.304a67.2 67.2 0 0 0 67.008-67.072V461.696a67.2 67.2 0 0 0-67.008-67.008zM512 696.32a67.2 67.2 0 0 1-67.072-67.072A67.2 67.2 0 0 1 512 562.304a67.2 67.2 0 0 1 67.072 67.008A67.2 67.2 0 0 1 512 696.384z m103.936-301.696H408.064V327.616c0-57.344 46.592-103.936 103.936-103.936 57.344 0 103.936 46.592 103.936 103.936v67.072z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/icon-nav-14.svg
// module id = lVvg
// module chunks = 3